module.exports = __webpack_public_path__ + "static/img/wenhua.3f4a4c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua.jpg
// module id = +7m1
// module chunks = 1